import {AppState} from '../app-state';

export const selectActiveUserState = (state: AppState) => state.activeUser;

export const selectActiveUser = (state: AppState) => state.activeUser.user;

export const selectActiveUserLens = (state: AppState) => state.activeUser.lens;

export const selectActiveUserRole = (state: AppState) => state.activeUser.role;

export const selectActiveUserAlertsCount = (state: AppState) => state.activeUser.alertsCount;
